import { render, staticRenderFns } from "./NewPaymentsTable.vue?vue&type=template&id=437f2846&scoped=true"
import script from "./NewPaymentsTable.vue?vue&type=script&lang=js"
export * from "./NewPaymentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437f2846",
  null
  
)

export default component.exports